export default __webpack_public_path__ + "files/btn_analysis_hover.png";